<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import Icon from '@/components/shared/Icon.vue'

const visible = ref(false)

function onScroll() {
  visible.value = window.scrollY >= window.innerHeight
}

function scrollToTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

onMounted(() => {
  window.addEventListener('scroll', onScroll, { passive: true })
  onScroll()
})
onUnmounted(() => window.removeEventListener('scroll', onScroll))
</script>

<template>
  <Transition name="scroll-top">
    <button v-if="visible" class="scroll-to-top" aria-label="Scroll to top" @click="scrollToTop">
      <Icon name="arrow_upward" size="md" />
    </button>
  </Transition>
</template>

<style scoped>
.scroll-to-top {
  position: fixed;
  bottom: 1.5rem;
  right: 1.5rem;
  z-index: 200;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  background: var(--color-primary);
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  transition: background 0.15s, transform 0.15s, box-shadow 0.15s;
}

.scroll-to-top:hover {
  background: var(--primary-700, var(--color-primary));
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
}

.scroll-to-top:active {
  transform: translateY(0);
}

.scroll-to-top:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(var(--primary-rgb), 0.4), 0 2px 8px rgba(0, 0, 0, 0.2);
}

.scroll-top-enter-active,
.scroll-top-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}

.scroll-top-enter-from,
.scroll-top-leave-to {
  opacity: 0;
  transform: translateY(0.5rem);
}
</style>
